const defaultState = {
  initialUrl: '',
  linkAction: '',
  ctaUserDetail: {},
  userName: ''
};

const engagement = (state = defaultState, action) => {
  const { payload, type } = action;

  switch (type) {
    case 'LOGOUT':
      return defaultState;

    case 'UPDATE_INITIAL_URL':
      return {
        ...state,
        initialUrl: payload
      };

    case 'UPDATE_LINK_ACTION':
      return {
        ...state,
        linkAction: payload
      };

    case 'UPDATE_CTA_USER_DETAIL':
      return {
        ...state,
        ctaUserDetail: payload
      };

    case 'UPDATE_USERNAME':
      return {
        ...state,
        userName: payload
      };
    default:
      return { ...state, language: state.language };
  }
};

export default engagement;
